import Layout from 'components/layout'
import Login from 'components/login'
import ShareContainer from 'components/share-container'
import AdContainer from 'components/ad-container'
import DemoContainer from 'components/demo-container'
import authService from 'service/authService'

// 页面路由配置
export default [
  {
    path: '/user',
    component: Login,
    meta: {
      title: '分享收客'
    },
    children: [
      // 登陆页模块
      {
        path: 'login',
        component: (r) => require(['views/home/login'], r),
        meta: {
          title: '分享收客登陆'
        }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    meta: {
      title: '分享收客'
    },
    children: [
      // 默认
      {
        path: '',
        redirect: 'index'
      },

      // 首页模块
      {
        path: 'index',
        component: (r) => require(['views/home/index'], r),
        meta: {
          title: '分享收客'
        }
      },

      // 微信授权成功页模块
      {
        path: 'grantsuccess',
        component: (r) => require(['views/content/grantsuccess'], r),
        meta: {
          title: '微信授权成功'
        }
      },

      // 内容模块
      {
        path: 'share',
        component: ShareContainer,
        meta: {
          title: '内容管理',
          requireAuth: true
        },
        children: [
          // 测试模块
          {
            path: '/share/test',
            component: r => require(['views/test/test'], r)
          },
          // 内容管理模块
          {
            path: '',
            redirect: '/share/my-content'
          },
          {
            path: '/share/my-content',
            component: (r) => require(['views/content/myContent'], r),
            meta: {
              title: '我的内容'
            }
          },
          {
            path: '/share/platform-content',
            component: (r) => require(['views/content/platformContent'], r),
            meta: {
              title: '平台内容'
            }
          },
          {
            path: '/share/create',
            component: (r) => require(['views/distributor/charge'], r),
            meta: {
              title: '制作内容'
            }
          },
          {
            path: '/share/category-list',
            component: (r) => require(['views/content/categoryList'], r),
            meta: {
              title: '内容分类管理'
            }
          },
          {
            path: '/share/banner',
            component: (r) => require(['views/content/banner'], r),
            meta: {
              title: 'Banner管理'
            }
          },
          {
            path: '/share/product',
            component: (r) => require(['views/content/product'], r),
            meta: {
              title: '推荐内容',
              requireAdmin: true
            }
          },
          {
            path: '/weixin/authorize',
            component: (r) => require(['views/weixin/authorize'], r),
            meta: {
              title: '授权平台'
            }
          },
          {
            path: '/weixin/authorize-history',
            component: (r) => require(['views/weixin/authorizeHistory'], r),
            meta: {
              title: '授权记录',
              requireAdmin: true
            }
          },
          {
            path: '/weixin/menus',
            component: (r) => require(['views/weixin/menus'], r),
            meta: {
              title: '菜单管理'
            }
          }
        ]
      },

      // 营销模块
      {
        path: 'ad',
        component: AdContainer,
        meta: {
          title: '精准营销',
          requireAuth: true
        },
        children: [
          // 广告管理模块
          {
            path: '',
            redirect: '/ad/stats'
          },
          {
            path: '/ad/stats',
            component: (r) => authService.isAdmin() ? require(['views/ad/customer'], r) : require(['views/ad/stats'], r),
            meta: {
              title: '广告统计'
            }
          },
          {
            path: '/ad/stats/detail',
            component: (r) => require(['views/ad/detail'], r),
            meta: {
              title: '统计详情'
            }
          },
          {
            path: '/ad/create',
            component: (r) => require(['views/distributor/newad'], r),
            meta: {
              title: '新建广告'
            }
          },
          {
            path: '/ad/flow-analysis',
            component: (r) => require(['views/ad/flow'], r),
            meta: {
              title: '客流分析'
            }
          },
          // 客户列表
          {
            path: '/ad/customer',
            component: (r) => require(['views/ad/customer'], r)
          },

          // 盒子管理模块
          {
            path: '/box/list',
            component: (r) => require(['views/distributor/boxlist'], r),
            meta: {
              title: '盒子列表'
            }
          },
          {
            path: '/box/create',
            component: (r) => require(['views/distributor/newbox'], r),
            meta: {
              title: '添加盒子'
            }
          },

          // 账户管理模块
          {
            path: '/account/top-up',
            component: (r) => require(['views/ad/topUp'], r),
            meta: {
              title: '财务报表'
            }
          },
          {
            path: '/account/accountuser',
            component: (r) => require(['views/ad/accountuser'], r),
            meta: {
              title: '客户账单',
              requireAdmin: true
            }
          },
          {
            path: '/account/soundtooth',
            component: (r) => require(['views/ad/soundtooth'], r),
            meta: {
              title: '声牙账单',
              requireAdmin: true
            }
          },
          {
            path: '/account/stats',
            component: (r) => require(['views/distributor/stats'], r),
            meta: {
              title: '广告管理'
            }
          },
          {
            path: '/account/recharge',
            component: (r) => require(['views/distributor/charge'], r),
            meta: {
              title: '账户充值'
            }
          }
        ]
      },

      // 示例模块
      {
        path: 'demo',
        component: DemoContainer,
        children: [
          {
            path: '/demo/list',
            component: (r) => require(['views/demo/list'], r),
            meta: {
              title: '制作内容'
            }
          },
          {
            path: '/demo/form',
            component: (r) => require(['views/demo/form'], r),
            meta: {
              title: '制作内容'
            }
          }
        ]
      },

      // 特殊页面
      {
        // 无权限页面
        path: 'no-priv',
        name: 'no-priv',
        component: (r) => require(['views/common/noPermission'], r),
        meta: {
          title: '没有权限'
        }
      },
      {
        // 404 页面
        path: '*',
        name: 'not-found',
        component: (r) => require(['views/common/notFound'], r),
        meta: {
          title: '页面未找到'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js